































































import { Vue, Prop, Component } from 'vue-property-decorator';
import toCurrency from '@/shared/directive/toCurrency';
import Headers from './items-table-headers.json';

@Component({
  filters: { toCurrency },
})
export default class BillingInfoContentItemsTable extends Vue {
  @Prop({
    required: true,
  })
  items!: any;

  @Prop({
    required: true,
  })
  currency!: any;

  headers: any = Headers;

  currencyFormat: any = toCurrency;
}
